
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Form, Input, Label, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { getTeams } from 'store/actions';
import Select from 'react-select';
import TeamPerformanceTable from './TeamPerformanceTable';
import Breadcrumb from 'components/Common/Breadcrumb2';
import axiosInstance from 'pages/Utility/axiosInstance';

const TeamPerformanceReport = () => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const permissions = JSON.parse(localStorage?.getItem('permissions'));
    const teams = useSelector(state => state?.Team?.teams);
    const [teamPerformanceData, setTeamPerformanceData] = useState();
    const [selectedTeam, setSelectedTeam] = useState();
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch();

    const getCurrentMonthRange = () => {
        const now = new Date();
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 2);
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 1);

        const formatDate = (date) => date.toISOString().split("T")[0]; // Convert to YYYY-MM-DD format

        return {
            startDate: formatDate(firstDay),
            endDate: formatDate(lastDay),
        };
    };

    const [startDate, setStartDate] = useState(getCurrentMonthRange().startDate);
    const [endDate, setEndDate] = useState(getCurrentMonthRange().endDate);

    const fetchTeamPerformance = async () => {
        setLoading(true)
        try {
            const response = await axiosInstance.get('', { params: { sp: "usp_GetTeamsPerformenceAnalysis", teamId: selectedTeam?.value ? selectedTeam?.value : 0, fromDate: startDate, toDate: endDate } })
            if (response) {
                setTeamPerformanceData(response?.data?.Data)
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
        }
    }

    const teamOptions = teams?.Data?.map(item => ({ label: item?.teamName, value: item?.teamId }))

    useEffect(() => {
        if (loading) return;
        dispatch(getTeams(true));
        fetchTeamPerformance();
    }, [dispatch]);

    const handleSearch = () => {
        if (new Date(startDate) > new Date(endDate)) {
            showError("End datetime must be after start datetime");
        } else {
        fetchTeamPerformance();
        }
    }

    return (
        <>
            <div className='page-content container-fluid'>
                <div className='d-flex justify-content-between align-items-center mx-3'>
                    <Breadcrumb
                        title="Team Performance"
                        breadcrumbItems={[
                            { title: "Dashboard", link: `/dashboard` },
                            { title: "Team Performance", link: '#' },
                        ]}
                    />
                </div>

                <Form className="my-3 mx-3">
                    <Row form>
                        {/* Start Date */}
                        <Col xs={6} md={3}>
                            <Label for="startDate">Start Date</Label>
                            <Input
                                type="date"
                                id="startDate"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                style={{ height: "38px", border: "1px solid lightgray" }}
                            />
                        </Col>

                        {/* End Date */}
                        <Col xs={6} md={3}>
                            <Label for="endDate">End Date</Label>
                            <Input
                                type="date"
                                id="endDate"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                style={{ height: "38px", border: "1px solid lightgray" }}
                            />
                        </Col>

                        {/* Team Selector */}
                        <Col xs={6} md={3}>
                            <Label for="team">Team</Label>
                            <Select
                                id="team"
                                options={teamOptions}
                                value={selectedTeam}
                                onChange={setSelectedTeam}
                                placeholder="Select Team"
                                isClearable={true}
                            />
                        </Col>

                        <Col xs={6} md={3}>
                            <Button color="primary" style={{ marginTop: "30px" }} onClick={handleSearch}>Search</Button>
                        </Col>
                    </Row>
                </Form>

                <TeamPerformanceTable loading={loading} List={teamPerformanceData} />
            </div>
        </>
    );
};

export default TeamPerformanceReport;
